/**
 * @generated SignedSource<<35828779179471c2be88cef8493d19d3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespSidebarBlurbShipping_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoWrapper_user">;
  readonly " $fragmentType": "PdpRespSidebarBlurbShipping_user";
};
export type PdpRespSidebarBlurbShipping_user$key = {
  readonly " $data"?: PdpRespSidebarBlurbShipping_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespSidebarBlurbShipping_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6702fb18f686042852bdbbdf3ffc22a5";

export default node;
